import { Box, CircularProgress } from "@mui/material";

export const LoadingFallback = () => (
  <Box
    sx={{
      display: "flex",
      width: "100%",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <CircularProgress />
  </Box>
);
